import ErrorLogger from './ErrorLogger'
export default ErrorLogger
